import {
  checkRentalPortalListingsExportTask,
  loadRentalPortalListingsExportFieldsList,
  startRentalPortalListingsExport,
} from '../../../../../api'
import { getApiRequestFilterParams } from '../../../../../utils/filter'
import { TableExportModal } from '../../../../Table'

export function useRentalPortalListingsExport({
  excludeIds,
  filterValues,
  selectAllPages,
  selectedIds,
  setModal,
  onCleanSelection,
  onClose,
}) {
  function handleOpenExport() {
    setModal(
      <TableExportModal
        checkTask={checkRentalPortalListingsExportTask}
        loadFieldList={loadRentalPortalListingsExportFieldsList}
        startExport={startRentalPortalListingsExport}
        tableExportGetResponseLinkModalProps={{
          excludeIds,
          filterValues,
          getApiRequestFilterParams,
          selectAllPages,
          selectedIds,
          unselectAllPages: onCleanSelection,
        }}
        onClose={onClose}
      />
    )
  }

  return { handleOpenExport }
}
